// src/components/SignupForm.js
import React, { useState } from 'react';
import './SignupForm.css';
import { Link, useNavigate } from 'react-router-dom';

const SignupForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
  });

      const [modalVisible, setModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' })); // clear error on change
  };

  const togglePassword = () => setShowPassword(!showPassword);

  const validate = () => {
    const newErrors = {};
    const { password, confirmPassword } = formData;

    if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters long.';
    } else if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) {
      newErrors.password = 'Password must contain both letters and digits.';
    }

    if (confirmPassword !== password) {
      newErrors.confirmPassword = 'Passwords doesnt match.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await fetch('https://pst-file-uploader.finkraftai.com/api/send-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate('/verify', { state: { email: formData.email, password: formData.password } });
      } 
       else if (response.status === 409) {
  // alert(data.message || 'User already exists, try to login');
  setModalMessage(data.message);
      setModalVisible(true);
} else {
        alert(data.message || 'Failed to send OTP');
         setModalMessage(data.message);
      setModalVisible(true);
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  };
  

  return (
    <>
     {modalVisible && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>Login Info</h3>
            <p style={styles.modalText}>{modalMessage}</p>
            <button onClick={() => setModalVisible(false)} style={styles.modalButton}>Close</button>
          </div>
        </div>
      )}
    <div className="signup-form-container">
      <h2>Sign Up</h2>
      <p>Provide the following information to create an account.</p>

      <form onSubmit={handleSubmit}>
        <label>
          Email Address *
          <input
            type="email"
            name="email"
            placeholder="Enter email address"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Password *
          <div className="password-input">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button type="button" onClick={togglePassword} className="eye-btn">👁️</button>
          </div>
          {errors.password && (
  <p style={{ color: 'red', fontSize: '0.85rem', marginTop: '4px', marginLeft: '4px' }}>
    {errors.password}
  </p>
)}

        </label>

        <label>
          Confirm Password *
          <div className="password-input">
            <input
              type={showPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Confirm password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <button type="button" onClick={togglePassword} className="eye-btn">👁️</button>
          </div>
          {errors.confirmPassword && (
  <p style={{ color: 'red', fontSize: '0.85rem', marginTop: '4px', marginLeft: '4px' }}>
    {errors.confirmPassword}
  </p>
)}

        </label>

        <button type="submit" className="submit-btn">Continue</button>

        <p className="signin-link">
          Already have an account? <Link to='/'>Sign in</Link>
        </p>
      </form>
    </div>
    </>
  );
};


const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: '2rem',
    maxWidth: '400px',
    margin: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  input: {
    padding: '0.75rem',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
  },
  button: {
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999, // ADD this: high z-index to cover everything
  },
  modal: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    width: '300px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    zIndex: 10000, // ADD this: modal should be above overlay (optional)
  },
  modalTitle: {
    marginBottom: '1rem',
  },
  modalText: {
    marginBottom: '1.5rem',
  },
  modalButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  }
};

export default SignupForm;
